import {FC} from 'react'
import {OrderItemModel} from '../models/OrderItemModel'
import {ItemStatus, PaymentStatus} from '../constants'
import {Link} from 'react-router-dom'
import {KTSVG} from '../../../../_metronic/helpers'
import Tooltip from 'react-tooltip-lite'
import {useIntl} from 'react-intl'
import {useDispatch} from 'react-redux'
import {retryAi, setCurrent as setCurrentItem} from '../../items/redux/itemRedux'
import {MAX_AI_TRY_TIME} from '../../items/constants'
type Props = {
  item: OrderItemModel
}
const ItemActionBox: FC<Props> = (props) => {
  const dispatch = useDispatch()
  const id = props.item.id
  const intl = useIntl()
  const handleEditButtonClick = (e: any) => {
    if (props.item.paymentStatus != PaymentStatus.PAID) {
      e.preventDefault() // Prevent the Link from navigating
      e.stopPropagation() // Stop the event from propagating further
    }
  }
  const editable =
    props.item.paymentStatus == PaymentStatus.PAID && props.item.status == ItemStatus.DONE
  const retryLeft = Math.max(MAX_AI_TRY_TIME - (props.item.aiCountTime ?? 0), 0)
  const canRetry = [ItemStatus.FAIL, ItemStatus.DONE].includes(props.item.status) && retryLeft > 0
  const handleRetry = () => {
    if (!canRetry) {
      return
    }
    dispatch(setCurrentItem(props.item))
    dispatch(retryAi(props.item.itemOptions || []))
  }
  return (
    <div className='d-flex align-items-center flex-wrap gap-2'>
      <Tooltip
        content={intl.formatMessage({
          id: !editable
            ? props.item.paymentStatus == PaymentStatus.PAID
              ? 'ITEM.ACTIONS.EDIT.PENDING'
              : 'ITEM.ACTIONS.EDIT.DISABLE'
            : 'ITEM.ACTIONS.EDIT',
        })}
        className='tooltips'
      >
        <Link
          to={'/edit/' + id.toString()}
          onClick={handleEditButtonClick}
          className={`btn btn-icon btn-light-primary btn-sm ${
            !editable ? 'disabled opacity-50 pointer-events-none' : ''
          }`}
          title='Edit Item'
        >
          <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
        </Link>
      </Tooltip>
      {canRetry && (
        <Tooltip
          content={
            intl.formatMessage({id: 'ORDER.ACTIONS.RETRY'}) + ' (' + retryLeft.toString() + ')'
          }
          className='tooltips'
        >
          <button
            type='button'
            className='btn btn-icon btn-light-warning btn-sm'
            onClick={handleRetry}
          >
            <KTSVG
              path={'/media/icons/duotune/arrows/arr029.svg'}
              className='svg-icon svg-icon-2x svg-icon-warning'
            />
          </button>
        </Tooltip>
      )}
    </div>
  )
}
export default ItemActionBox
